import React from 'react';
import { Trans } from 'react-i18next';
import { GetFormatLoanAgreement } from '../../../AppUtil/AppUtil';
const LOAN_TYPES = window.AppConfig.LOAN_TYPES;
const trimTheText = (text) => {
    if(text){
        return (text).trim();
    }
    return "";
};
function Header (props) { // NOSONAR
    const loanObject = props.loanObject;
    const lender = {};
    const borrower = {};

    if (loanObject.loan_type === LOAN_TYPES.LEND) {
        if (loanObject.accepted_by === props._currentUserId) {
            borrower.name = loanObject.created_by_user.name;
            borrower.address = trimTheText(loanObject.created_by_user.address);
            borrower.state = props.hashedSupportedStates[loanObject.created_by_user.state].name || '';
            borrower.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
            borrower.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
            lender.name = loanObject.accepted_by_user.name;
            lender.address = trimTheText(loanObject.accepted_by_user.address);
            lender.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
            lender.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
            

        } else {
            borrower.name = loanObject.accepted_by_user.name;
            borrower.address = trimTheText(loanObject.accepted_by_user.address);
            borrower.state = props.hashedSupportedStates[loanObject.accepted_by_user.state].name || '';
            borrower.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
            borrower.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
            lender.name = loanObject.created_by_user.name;
            lender.address = trimTheText(loanObject.created_by_user.address);
            lender.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
            lender.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
            
        }

    } else {
        if (loanObject.accepted_by === props._currentUserId) {
            borrower.name = loanObject.accepted_by_user.name;
            borrower.address = trimTheText(loanObject.accepted_by_user.address);
            borrower.state = props.hashedSupportedStates[loanObject.accepted_by_user.state].name || '';
            borrower.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
            borrower.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
            lender.name = loanObject.created_by_user.name;
            lender.address = trimTheText(loanObject.created_by_user.address);
            lender.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
            lender.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
            

        } else {
            borrower.name = loanObject.created_by_user.name;
            borrower.address = trimTheText(loanObject.created_by_user.address);
            borrower.state = props.hashedSupportedStates[loanObject.created_by_user.state].name || '';
            borrower.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
            borrower.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
            lender.name = loanObject.accepted_by_user.name;
            lender.address = trimTheText(loanObject.accepted_by_user.address);
            lender.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
            lender.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
            
        }

    }
    const start_date = GetFormatLoanAgreement(props.loanObject.start_date);
    const lender_name = lender.name;
    const lender_address = lender.address + ', ' + lender.city + ', ' +
                        props.hashedSupportedStates[props.loanObject.lender_state].name + ', ' + lender.postalCode;

    const borrower_name = borrower.name;
    const borrower_address = borrower.address + ', ' + borrower.city + ', ' + borrower.state + ', ' + borrower.postalCode;
    
    const guarantor = {};
    if(props.loanObject.guarantor_details[0]){
        guarantor.name = props.loanObject.guarantor_details[0].name;
        guarantor.address = props.loanObject.guarantor_details[0].address || '';
        guarantor.city = props.loanObject.guarantor_details[0].city || '';
        guarantor.postalCode = props.loanObject.guarantor_details[0].postalCode || '';
        guarantor.state = props.hashedSupportedStates[props.loanObject.guarantor_details[0].state].name || '';
    }

    const guarantor_address = guarantor.address + ', ' + guarantor.city + ', ' + guarantor.state + ', ' + guarantor.postalCode;
    const guarantor_name = guarantor.name;
    return (
        <>
            <Trans i18nKey='loan_agreement_guarantor_borrower.header'>
                <p><strong>KNOW ALL MEN BY THESE PRESENTS</strong></p>
                <p>This Contract of Guaranty (hereinafter referred to as “Guaranty”)
                made and executed on {{ start_date }}  at LendAmi by and between:</p>
                <p><strong>Parties</strong></p>

                <p style={{paddingLeft: "2rem", paddingRight: "2rem"}}>{{ borrower_name }}, Filipino, of legal age and capacity, with residence address at
                {{ borrower_address }} (“the BORROWER”)</p> 
                <p style={{textAlign: "center"}}>and</p>
                <p style={{paddingLeft: "2rem", paddingRight: "2rem"}}>{{ guarantor_name }}, Filipino, of legal age and capacity,  
                with residence address at {{ guarantor_address }}, 
                (“the GUARANTOR”)</p>
                <p style={{textAlign: "center"}}>(collectively known as the “PARTIES”).</p>
                <p style={{textAlign: "center"}}><strong>Recitals</strong></p>
                <p><strong><i>WITNESSETH THAT: </i></strong></p>
                <p><strong>WHEREAS</strong>, the BORROWER borrowed money (the “Loan”) from {{ lender_name }}, Filipino, of legal age and capacity, with postal address at {{ lender_address }} (“the LENDER”); </p>
                <p><strong>WHEREAS</strong>, the Loan is subject to the terms and conditions of the Loan
                        Agreement Promissory Note (the “Agreement”) to which this
                        Guaranty is attached to as Annex “A”;</p>
                <p><strong>WHEREAS</strong>, subject to the terms and conditions in this Guaranty, the
                        GUARANTOR has agreed to pay the LENDER the Loan and interest if
                        the BORROWER fails to pay; </p>
                <p style={{fontWeight: "bold"}}><strong>Terms and conditions</strong></p>
                <p>
                <strong>NOW, THEREFORE</strong>, for and in consideration of the Recitals above and
                the promises that the PARTIES made to each other in this Guaranty,
                they have agreed as follows:
                </p>

            </Trans>
        </>
    );

}

export default Header;
